// Perfiles metrológicos de DIMENSIONAL.
// Convención única: error = indicación del instrumento - valor corregido del patrón.

const SQRT3 = Math.sqrt(3);

function block(key, label, options = {}) {
  return { key, label, referenceSeries: options.referenceSeries || null, pointCount: options.pointCount || null };
}

export const DIMENSIONAL_TEMPLATES = [
  {
    code: 'DIM-LONG:caliper:v1', revision: '2', subfamily: 'longitud', profileKey: 'caliper',
    profileLabel: 'Calibre pie de rey', title: 'Calibración de calibres pie de rey', objectFallback: 'Calibre pie de rey',
    unit: 'mm', pointCount: 6, repeatCount: 2, measurementMode: 'comparison',
    functionKeys: ['gauge_block', 'caliper_step'], defaultSetpoints: [1, 5, 10, 30, 50, 100],
    blocks: [block('outside', 'Medición exterior (A)', { referenceSeries: 'outside' }), block('inside', 'Medición interior (B)', { referenceSeries: 'inside' }), block('depth', 'Profundidad (C)', { referenceSeries: 'outside' }), block('step', 'Escalón (E)', { referenceSeries: 'outside' })],
    method: 'Por comparación directa con bloques patrón y patrón escalonado certificados.', procedure: 'P-DT-PT-16-00 (Calibración de calibres)',
  },
  {
    code: 'DIM-LONG:micrometer:v1', revision: '2', subfamily: 'longitud', profileKey: 'micrometer',
    profileLabel: 'Micrómetro', title: 'Calibración de micrómetros', objectFallback: 'Micrómetro',
    unit: 'mm', pointCount: 6, fineResolutionPointCount: 11, repeatCount: 10, minimumReadingsPerPoint: 10, measurementMode: 'comparison',
    functionKeys: ['gauge_block'], defaultSetpoints: [0, 5, 10, 15, 20, 25],
    blocks: [block('external', 'Medición exterior (dos contactos)')],
    method: 'Por comparación directa con bloques patrón certificados.', procedure: 'P-DT-PT-22-00 (Calibración de micrómetros)',
  },
  {
    code: 'DIM-LONG:rule:v1', revision: '1', subfamily: 'longitud', profileKey: 'rule_flexometer',
    profileLabel: 'Regla / flexómetro', title: 'Calibración de reglas y flexómetros', objectFallback: 'Regla / flexómetro',
    unit: 'mm', pointCount: 6, repeatCount: 2, measurementMode: 'comparison',
    functionKeys: ['caliper_step'], defaultSetpoints: [20, 50, 100, 200, 400, 600],
    blocks: [block('linear', 'Longitud lineal', { referenceSeries: 'outside' })],
    method: 'Por comparación directa con patrón longitudinal certificado.', procedure: 'P-DT-PT-16-00 (Calibración dimensional)',
  },
  {
    code: 'DIM-LONG:depth:v1', revision: '1', subfamily: 'longitud', profileKey: 'depth_gauge',
    profileLabel: 'Calibre de profundidad', title: 'Calibración de calibres de profundidad', objectFallback: 'Calibre de profundidad',
    unit: 'mm', pointCount: 6, repeatCount: 4, measurementMode: 'comparison',
    functionKeys: ['gauge_block', 'caliper_step'], defaultSetpoints: [1, 5, 20, 50, 100, 150],
    blocks: [block('depth', 'Profundidad', { referenceSeries: 'outside' })],
    method: 'Por comparación directa con bloques patrón y patrón escalonado certificados.', procedure: 'P-DT-PT-16-00 (Calibración dimensional)',
  },
  {
    code: 'DIM-THICK:ultrasonic:v1', revision: '1', subfamily: 'espesor', profileKey: 'ultrasonic_thickness',
    profileLabel: 'Medidor ultrasónico de espesores', title: 'Calibración de medidores ultrasónicos de espesor', objectFallback: 'Medidor ultrasónico de espesores',
    unit: 'mm', pointCount: 9, repeatCount: 2, measurementMode: 'comparison',
    functionKeys: ['thickness_reference'], defaultSetpoints: [0, 1, 3, 10, 20, 30, 50, 80, 100],
    blocks: [block('thickness', 'Espesor')],
    method: 'Por comparación con medidor o bloque patrón certificado.', procedure: 'P-DT-PT-24-00 (Medidor de espesores)',
  },
  {
    code: 'DIM-THICK:coating:v1', revision: '1', subfamily: 'espesor', profileKey: 'coating_roughness',
    profileLabel: 'Espesor de revestimiento / rugosímetro', title: 'Calibración de medidores de revestimiento y rugosímetros', objectFallback: 'Medidor de revestimiento / rugosímetro',
    unit: 'mm', pointCount: 6, repeatCount: 8, measurementMode: 'comparison',
    readingLabels: ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'E1', 'E2'],
    functionKeys: ['thickness_reference', 'gauge_block'], defaultSetpoints: [0.005, 0.1, 0.5, 0.6, 0.8, 1],
    blocks: [block('coating', 'Espesor / profundidad de perfil')],
    method: 'Por sustitución y comparación con patrón dimensional certificado.', procedure: 'P-DT-PT-16-00 (Calibración dimensional)',
  },
  {
    code: 'DIM-THICK:ultrasonic_angular:v1', revision: '1', subfamily: 'espesor', profileKey: 'ultrasonic_angular',
    profileLabel: 'Ultrasonido angular', title: 'Calibración de equipos de ultrasonido angular', objectFallback: 'Equipo de ultrasonido angular',
    unit: 'mm', pointCount: 7, repeatCount: 4, measurementMode: 'bidirectional',
    functionKeys: ['thickness_reference'], defaultSetpoints: [25.5, 35, 41, 46, 50.5, 58.8, 70],
    blocks: [block('angular_path', 'Recorrido sónico')],
    method: 'Por comparación con referencia dimensional certificada en ciclos ascendente y descendente.', procedure: 'P-DT-PT-24-00 (Medición por ultrasonido)',
  },
  {
    code: 'DIM-SPECIAL:comparator:v1', revision: '1', subfamily: 'especial', profileKey: 'comparator',
    profileLabel: 'Comparador', title: 'Calibración de comparadores', objectFallback: 'Comparador',
    unit: 'mm', pointCount: 11, repeatCount: 4, minimumReadingsPerPoint: 8,
    measurementMode: 'bidirectional', repeatabilityMode: 'within_directions',
    functionKeys: ['gauge_block'], defaultSetpoints: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    blocks: [block('comparison', 'Desplazamiento')],
    method: 'Por comparación directa con bloques patrón certificados en ciclos ascendentes y descendentes.',
    procedure: 'P-DT-PT-23-00 (Calibración de comparadores)',
    guidance: 'Usá 11 puntos aproximadamente equidistantes que cubran, preferentemente, al menos el 90 % del alcance. Completá las cuatro series ascendentes y las cuatro descendentes sin invertir el sentido dentro de cada recorrido.',
  },
  {
    code: 'DIM-SPECIAL:welding_gauge:v1', revision: '1', subfamily: 'especial', profileKey: 'welding_gauge',
    profileLabel: 'Calibre de soldadura · escala lineal', title: 'Calibración lineal de calibres de soldadura', objectFallback: 'Calibre de soldadura',
    unit: 'mm', pointCount: 6, repeatCount: 4, minimumReadingsPerPoint: 4, measurementMode: 'comparison',
    functionKeys: ['gauge_block', 'caliper_reference'], defaultSetpoints: [0, 5, 10, 15, 20, 25],
    blocks: [block('linear_scale', 'Escala lineal')],
    method: 'Por comparación directa de la escala lineal con bloques patrón o instrumento dimensional certificado.',
    procedure: 'Método dimensional específico para calibres de soldadura',
    guidance: 'Este perfil verifica únicamente magnitudes lineales: altura, profundidad, desalineación, garganta o pierna según el diseño del calibre. Si el equipo incluye escala angular, realizá también el perfil angular.',
  },
  {
    code: 'DIM-ANGLE:welding_gauge:v1', revision: '1', subfamily: 'especial', profileKey: 'welding_gauge_angle',
    profileLabel: 'Calibre de soldadura · escala angular', title: 'Calibración angular de calibres de soldadura', objectFallback: 'Calibre de soldadura angular',
    unit: '°', pointCount: 7, repeatCount: 3, minimumReadingsPerPoint: 3, measurementMode: 'comparison',
    functionKeys: ['angle_reference'], defaultSetpoints: [0, 10, 20, 30, 40, 50, 60],
    blocks: [block('angle_scale', 'Escala angular')],
    method: 'Por comparación directa con patrón angular certificado o proyector de perfiles trazable.',
    procedure: 'Método dimensional específico para calibres de soldadura',
    guidance: 'Usá este perfil para ángulos de preparación o bisel. La escala lineal del mismo instrumento debe verificarse en una sesión lineal independiente.',
  },
  {
    code: 'DIM-SPECIAL:three_contact:v1', revision: '1', subfamily: 'especial', profileKey: 'three_contact_gauge',
    profileLabel: 'Calibre de tres contactos', title: 'Calibración de calibres de tres contactos', objectFallback: 'Calibre de tres contactos',
    unit: 'mm', pointCount: 7, repeatCount: 4, measurementMode: 'comparison',
    functionKeys: ['caliper_step'], defaultSetpoints: [20, 50, 100, 150, 200, 300, 350],
    blocks: [block('inside', 'Diámetro interior', { referenceSeries: 'inside' })],
    method: 'Por comparación con la escala interior del patrón escalonado certificado.', procedure: 'P-DT-PT-16-00 (Calibración dimensional)',
  },
  {
    code: 'DIM-SPECIAL:thread_gauge:v1', revision: '1', subfamily: 'especial', profileKey: 'thread_gauge',
    profileLabel: 'Peine de roscas', title: 'Calibración y control de peines de rosca', objectFallback: 'Peine de roscas',
    unit: 'mm', pointCount: 5, repeatCount: 3, measurementMode: 'comparison',
    functionKeys: ['caliper_reference'], defaultSetpoints: [2, 5, 10, 20, 30],
    blocks: [block('dimensions', 'Dimensiones verificadas')],
    method: 'Por sustitución y comparación con calibre patrón certificado, incluyendo control visual del perfil.', procedure: 'P-DT-PT-16-00 (Calibración dimensional)',
  },
  {
    code: 'DIM-SPECIAL:reference_piece:v1', revision: '1', subfamily: 'especial', profileKey: 'reference_piece',
    profileLabel: 'Pieza / probeta patrón', title: 'Calibración dimensional de piezas y probetas patrón', objectFallback: 'Pieza / probeta patrón',
    unit: 'mm', pointCount: 8, repeatCount: 3, measurementMode: 'comparison',
    functionKeys: ['caliper_reference'], defaultSetpoints: [5, 10, 16.8, 20, 23.8, 25, 34.6, 50],
    blocks: [block('x_axis', 'Lecturas en X'), block('y_axis', 'Lecturas en Y'), block('dimensions', 'Cotas dimensionales')],
    method: 'Por comparación con instrumento patrón certificado según cotas identificadas.', procedure: 'P-DT-PT-16-00 (Calibración dimensional)',
  },
  {
    code: 'DIM-SPECIAL:sieve:v1', revision: '1', subfamily: 'especial', profileKey: 'sieve',
    profileLabel: 'Tamiz', title: 'Calibración dimensional de tamices', objectFallback: 'Tamiz',
    unit: 'mm', pointCount: 4, repeatCount: 3, measurementMode: 'comparison',
    functionKeys: ['caliper_reference'], defaultSetpoints: [5, 5, 5, 5],
    blocks: [block('horizontal', 'Abertura horizontal'), block('vertical', 'Abertura vertical')],
    method: 'Por comparación en cuatro sectores y dos ejes con instrumento patrón certificado.', procedure: 'P-DT-PT-16-00 (Calibración dimensional)',
  },
  {
    code: 'DIM-ANGLE:goniometer_level:v1', revision: '1', subfamily: 'especial', profileKey: 'goniometer_level',
    profileLabel: 'Goniómetro / nivel digital', title: 'Calibración de goniómetros y niveles digitales', objectFallback: 'Goniómetro / nivel digital',
    unit: '°', pointCount: 7, repeatCount: 3, measurementMode: 'bidirectional',
    functionKeys: ['angle_reference'], defaultSetpoints: [0, 15, 30, 45, 60, 75, 90],
    blocks: [block('angle', 'Ángulo')],
    method: 'Por comparación con patrón angular certificado en ciclos ascendente y descendente.', procedure: 'P-DT-PT-16-00 (Calibración dimensional)',
  },
];

export const DEFAULT_DIMENSIONAL_FAMILY_DATA = {
  profile_key: 'caliper', profile_label: 'Calibre pie de rey',
  method: '', procedure: '', tolerance_mode: 'absolute', decision_rule: 'simple',
  material: 'Acero', reference_temperature_c: 20, thermal_coefficient_per_c: 0.0000115,
  substrate: '', couplant: '', probe_model: '', nominal_probe_angle_deg: null,
  thread_system: 'Métrico', thread_profile_ok: true, teeth_condition_ok: true,
  piece_reference: '', sieve_number: '', nominal_aperture_mm: null,
  standard_configuration: { references: [] },
  standard_budget: { drift_mm: 0, flatness_um: 0, parallelism_um: 0, abbe_um: 0, other_uncertainty_mm: 0 },
  environment_readings: [
    { key: 'start_1', label: 'Inicio 1.er ciclo', temp_c: null, pressure_hpa: null, humidity_rh: null },
    { key: 'start_2', label: 'Inicio 2.do ciclo', temp_c: null, pressure_hpa: null, humidity_rh: null },
    { key: 'end_2', label: 'Fin 2.do ciclo', temp_c: null, pressure_hpa: null, humidity_rh: null },
  ],
};

const DIMENSIONAL_TEMPLATE_ALIASES = {
  'DIM-SPECIAL:comparator_welding:v1': 'DIM-SPECIAL:comparator:v1',
};

export function resolveDimensionalTemplate(templateCode) {
  const resolvedCode = DIMENSIONAL_TEMPLATE_ALIASES[templateCode] || templateCode;
  return DIMENSIONAL_TEMPLATES.find((item) => item.code === resolvedCode) || DIMENSIONAL_TEMPLATES[0];
}

export function defaultDimensionalFamilyData(templateCode) {
  const template = resolveDimensionalTemplate(templateCode);
  return {
    ...DEFAULT_DIMENSIONAL_FAMILY_DATA,
    profile_key: template.profileKey,
    profile_label: template.profileLabel,
    method: template.method,
    procedure: template.procedure,
    material: template.unit === '°' ? 'No aplica' : DEFAULT_DIMENSIONAL_FAMILY_DATA.material,
    thermal_coefficient_per_c: template.unit === '°' ? 0 : DEFAULT_DIMENSIONAL_FAMILY_DATA.thermal_coefficient_per_c,
  };
}

export function mergeDimensionalFamilyData(value = {}, templateCode = null) {
  const input = value && typeof value === 'object' ? value : {};
  const template = resolveDimensionalTemplate(templateCode || input.template_code || DIMENSIONAL_TEMPLATES.find((item) => item.profileKey === input.profile_key)?.code);
  const defaults = defaultDimensionalFamilyData(template.code);
  const references = Array.isArray(input?.standard_configuration?.references)
    ? input.standard_configuration.references
    : input?.standard_configuration?.reference ? [input.standard_configuration.reference] : [];
  const environment = Array.isArray(input.environment_readings) ? input.environment_readings : defaults.environment_readings;
  return {
    ...defaults, ...input,
    standard_budget: { ...defaults.standard_budget, ...(input.standard_budget || {}) },
    standard_configuration: { ...(input.standard_configuration || {}), references },
    environment_readings: defaults.environment_readings.map((fallback, index) => ({ ...fallback, ...(environment[index] || environment.find((item) => item?.key === fallback.key) || {}) })),
  };
}

export function resolveDimensionalPointCount(templateCode, instrumentResolution = null) {
  const template = resolveDimensionalTemplate(templateCode);
  const resolution = Math.abs(finiteOrNull(instrumentResolution) ?? 0);
  if (template.profileKey === 'micrometer' && resolution > 0 && resolution < 0.01) {
    return template.fineResolutionPointCount || 11;
  }
  return template.pointCount;
}

export function buildDimensionalBlocks(templateCode, options = {}) {
  const template = resolveDimensionalTemplate(templateCode);
  const resolvedPointCount = resolveDimensionalPointCount(templateCode, options.instrumentResolution);
  return template.blocks.map((item, index) => ({
    block_key: item.key, display_name: item.label, unit: `[${template.unit}]`, applicable: true,
    point_count: item.pointCount || resolvedPointCount, sort_order: index + 1, mode: template.measurementMode,
  }));
}

export function dimensionalReadingPairs(templateCode) {
  const template = resolveDimensionalTemplate(templateCode);
  const directions = template.measurementMode === 'bidirectional' ? ['ASC', 'DESC'] : ['NA'];
  return directions.flatMap((direction) => Array.from({ length: template.repeatCount }, (_, index) => ({
    key: `${direction.toLowerCase()}_${index + 1}`, direction, seriesNo: index + 1,
    label: direction === 'NA' ? (template.readingLabels?.[index] || `Lectura ${index + 1}`) : `${direction === 'ASC' ? 'Asc.' : 'Desc.'} ${index + 1}`,
    patternField: `${direction.toLowerCase()}_${index + 1}_pattern`,
    instrumentField: `${direction.toLowerCase()}_${index + 1}_instrument`,
  })));
}

export function finiteOrNull(value) {
  if (value === '' || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function summarizeDimensionalEnvironment(readings = [], referenceTemperature = 20) {
  const requiredKeys = ['start_1', 'start_2', 'end_2'];
  const source = Array.isArray(readings) ? readings : [];
  const ordered = requiredKeys.map((key, index) => source.find((item) => item?.key === key) || source[index] || {});
  const fields = ['temp_c', 'pressure_hpa', 'humidity_rh'];
  const values = Object.fromEntries(fields.map((field) => [field, ordered.map((item) => finiteOrNull(item?.[field]))]));
  const complete = fields.every((field) => values[field].every((value) => value !== null));
  const averageOrNull = (items) => {
    const finite = items.filter((value) => value !== null);
    return finite.length ? mean(finite) : null;
  };
  const reference = finiteOrNull(referenceTemperature) ?? 20;
  const temperatures = values.temp_c.filter((value) => value !== null);
  return {
    complete,
    ambient_temp_avg: averageOrNull(values.temp_c),
    ambient_pressure_avg: averageOrNull(values.pressure_hpa),
    ambient_humidity_avg: averageOrNull(values.humidity_rh),
    max_temperature_deviation: temperatures.length
      ? Math.max(...temperatures.map((value) => Math.abs(value - reference)))
      : null,
  };
}

function normalizeUnit(value) {
  return String(value || '').trim().toLowerCase().replace(/μ/g, 'µ').replace(/º/g, '°').replace(/\s+/g, '');
}

export function dimensionalToCanonical(value, unit, templateCode) {
  const numeric = finiteOrNull(value);
  if (numeric === null) return null;
  const template = resolveDimensionalTemplate(templateCode);
  const normalized = normalizeUnit(unit || template.unit);
  if (template.unit === '°') {
    if (['°', 'deg', 'grado', 'grados'].includes(normalized)) return numeric;
    if (normalized === 'rad') return numeric * 180 / Math.PI;
    throw new Error(`La unidad ${unit || '(sin unidad)'} no es angular.`);
  }
  if (normalized === 'mm') return numeric;
  if (['µm', 'um'].includes(normalized)) return numeric / 1000;
  if (normalized === 'cm') return numeric * 10;
  if (normalized === 'm') return numeric * 1000;
  if (['in', 'inch', 'pulg', 'pulgada'].includes(normalized)) return numeric * 25.4;
  throw new Error(`La unidad ${unit || '(sin unidad)'} no es dimensional admitida.`);
}

export function suggestDimensionalSetpoints(rangeMin, rangeMax, templateCode, blockKey = null, pointCount = null) {
  const template = resolveDimensionalTemplate(templateCode);
  const min = finiteOrNull(rangeMin);
  const max = finiteOrNull(rangeMax);
  if (['micrometer', 'comparator', 'welding_gauge', 'welding_gauge_angle'].includes(template.profileKey) && min !== null && max !== null && max > min) {
    const count = Math.max(2, Number(pointCount) || template.pointCount);
    const step = (max - min) / (count - 1);
    return Array.from({ length: count }, (_, index) => Number((min + step * index).toFixed(6)));
  }
  let values = [...template.defaultSetpoints];
  if (template.profileKey === 'sieve' && blockKey === 'vertical') values = [8, 8, 8, 8];
  if (min !== null) values = values.filter((value) => value >= min - 1e-9);
  if (max !== null && max > (min ?? -Infinity)) values = values.filter((value) => value <= max + 1e-9);
  return values;
}

function mean(values = []) {
  const finite = values.map(finiteOrNull).filter((value) => value !== null);
  return finite.length ? finite.reduce((sum, value) => sum + value, 0) / finite.length : null;
}

function sampleStandardDeviation(values = []) {
  const finite = values.map(finiteOrNull).filter((value) => value !== null);
  if (finite.length < 2) return 0;
  const average = mean(finite);
  return Math.sqrt(finite.reduce((sum, value) => sum + ((value - average) ** 2), 0) / (finite.length - 1));
}

function rss(values = []) {
  return Math.sqrt(values.reduce((sum, value) => sum + ((finiteOrNull(value) ?? 0) ** 2), 0));
}

function resultAxisValue(result = {}) {
  return finiteOrNull(result.indicated_value) ?? finiteOrNull(result.reference_value);
}

function compatibleResults(snapshot = {}, blockKey = null) {
  const results = Array.isArray(snapshot.results) ? snapshot.results : [];
  const requested = String(blockKey || '').toLowerCase();
  if (!requested) return results;
  const preferred = requested === 'inside' ? 'inside' : requested === 'outside' || requested === 'depth' || requested === 'step' || requested === 'linear' ? 'outside' : null;
  if (!preferred) return results;
  const filtered = results.filter((result) => String(result?.metadata?.series || result?.range_label || '').toLowerCase().includes(preferred));
  return filtered.length ? filtered : results;
}

function evaluateSnapshot(value, snapshot = {}, blockKey = null) {
  const raw = finiteOrNull(value);
  if (raw === null) return { valid: false, reason: 'Lectura patrón vacía.' };
  const capability = snapshot.capability || {};
  const metadata = capability.metadata || {};
  const rangeMin = finiteOrNull(capability.range_min);
  const rangeMax = finiteOrNull(capability.range_max);
  if (rangeMin !== null && raw < rangeMin - 1e-9) return { valid: false, reason: 'La lectura está por debajo del alcance del patrón.' };
  if (rangeMax !== null && raw > rangeMax + 1e-9) return { valid: false, reason: 'La lectura supera el alcance del patrón.' };
  const results = compatibleResults(snapshot, blockKey);
  const mode = metadata.reference_input_mode || results[0]?.metadata?.reference_input_mode || 'raw_indication';
  const coverageFactor = finiteOrNull(snapshot?.certificate?.coverage_factor) || finiteOrNull(results[0]?.coverage_factor) || 2;
  const constantU = finiteOrNull(metadata.certified_uncertainty_mm);
  if (mode === 'corrected_value') {
    const uncertainties = results.map((result) => finiteOrNull(result.uncertainty_expanded)).filter((item) => item !== null);
    const uncertaintyExpanded = constantU ?? (uncertainties.length ? Math.max(...uncertainties) : null);
    if (uncertaintyExpanded === null) return { valid: false, reason: 'El patrón no tiene incertidumbre documentada.' };
    return { valid: true, corrected_value: raw, correction: 0, uncertainty_expanded: Math.abs(uncertaintyExpanded), coverage_factor: coverageFactor, standard_uncertainty: Math.abs(uncertaintyExpanded) / coverageFactor, snapshot };
  }
  const resolution = Math.abs(finiteOrNull(capability.resolution) ?? 0);
  const tolerance = Math.max(resolution / 2, 1e-6);
  const exact = results.find((result) => {
    const axis = resultAxisValue(result);
    return axis !== null && Math.abs(axis - raw) <= tolerance;
  });
  if (!exact) return { valid: false, reason: 'La lectura no coincide con un punto certificado del patrón.' };
  const correction = finiteOrNull(exact.correction) ?? ((finiteOrNull(exact.reference_value) ?? raw) - (finiteOrNull(exact.indicated_value) ?? raw));
  const uncertaintyExpanded = finiteOrNull(exact.uncertainty_expanded) ?? constantU;
  const k = finiteOrNull(exact.coverage_factor) || coverageFactor;
  if (uncertaintyExpanded === null || k <= 0) return { valid: false, reason: 'El punto certificado no tiene incertidumbre utilizable.' };
  return { valid: true, corrected_value: raw + correction, correction, uncertainty_expanded: Math.abs(uncertaintyExpanded), coverage_factor: k, standard_uncertainty: Math.abs(uncertaintyExpanded) / k, snapshot };
}

export function evaluateDimensionalReference(value, session = {}, blockKey = null) {
  const familyData = mergeDimensionalFamilyData(session.family_data, session.template_code);
  const references = familyData.standard_configuration?.references || [];
  if (!references.length) return { valid: false, reason: 'No hay patrones fijados en la sesión.' };
  const attempts = references.map((snapshot) => evaluateSnapshot(value, snapshot, blockKey));
  return attempts.find((attempt) => attempt.valid) || { valid: false, reason: attempts.map((attempt) => attempt.reason).filter(Boolean).join(' ') || 'Ningún patrón cubre la lectura.' };
}

export function computeDimensionalPointMetrics(row = {}, session = {}, blockKey = null) {
  const template = resolveDimensionalTemplate(session.template_code);
  const pairs = dimensionalReadingPairs(template.code).map((pair) => ({
    ...pair, pattern: finiteOrNull(row[pair.patternField]), instrument: finiteOrNull(row[pair.instrumentField]),
  })).filter((pair) => pair.pattern !== null && pair.instrument !== null);
  if (!pairs.length) return null;
  if (template.minimumReadingsPerPoint && pairs.length < template.minimumReadingsPerPoint) {
    return {
      traceability_issue: `Completá las ${template.minimumReadingsPerPoint} lecturas requeridas en este punto.`,
      pattern_mean: mean(pairs.map((pair) => pair.pattern)),
      instrument_mean: mean(pairs.map((pair) => pair.instrument)),
    };
  }
  const evaluations = pairs.map((pair) => evaluateDimensionalReference(pair.pattern, session, blockKey));
  const invalid = evaluations.find((evaluation) => !evaluation.valid);
  if (invalid) return { traceability_issue: invalid.reason, pattern_mean: mean(pairs.map((pair) => pair.pattern)), instrument_mean: mean(pairs.map((pair) => pair.instrument)) };
  const patternValues = evaluations.map((evaluation) => evaluation.corrected_value);
  const instrumentValues = pairs.map((pair) => pair.instrument);
  const errors = instrumentValues.map((reading, index) => reading - patternValues[index]);
  const patternMean = mean(patternValues);
  const instrumentMean = mean(instrumentValues);
  const errorAbs = instrumentMean - patternMean;
  const errorPct = patternMean === 0 ? null : errorAbs / patternMean * 100;
  const directionMetrics = Object.fromEntries(['ASC', 'DESC'].map((direction) => {
    const indexes = pairs.map((pair, index) => pair.direction === direction ? index : -1).filter((index) => index >= 0);
    const directionErrors = indexes.map((index) => errors[index]);
    return [direction, {
      count: indexes.length,
      pattern_mean: mean(indexes.map((index) => patternValues[index])),
      instrument_mean: mean(indexes.map((index) => instrumentValues[index])),
      error_abs: mean(directionErrors),
      standard_deviation: sampleStandardDeviation(directionErrors),
    }];
  }));
  let repeatability = sampleStandardDeviation(errors);
  let uRepeatability = repeatability / Math.sqrt(pairs.length);
  if (template.repeatabilityMode === 'within_directions') {
    const usableDirections = Object.values(directionMetrics).filter((item) => item.count > 0);
    repeatability = Math.max(0, ...usableDirections.map((item) => item.standard_deviation));
    uRepeatability = Math.max(0, ...usableDirections.map((item) => item.standard_deviation / Math.sqrt(item.count)));
  }
  const familyData = mergeDimensionalFamilyData(session.family_data, template.code);
  const budget = familyData.standard_budget;
  const uPatternCalibration = Math.max(...evaluations.map((evaluation) => evaluation.standard_uncertainty));
  const patternResolutions = evaluations.map((evaluation) => finiteOrNull(evaluation.snapshot?.capability?.resolution)).filter((item) => item !== null);
  const uPatternResolution = patternResolutions.length ? Math.max(...patternResolutions.map((value) => Math.abs(value) / Math.sqrt(12))) : 0;
  const uInstrumentResolution = Math.abs(finiteOrNull(session.instrument_resolution) ?? 0) / Math.sqrt(12);
  const uDrift = Math.abs(finiteOrNull(budget.drift_mm) ?? 0) / SQRT3;
  const environmentSummary = summarizeDimensionalEnvironment(familyData.environment_readings, familyData.reference_temperature_c);
  const deltaTemperature = template.profileKey === 'caliper' && environmentSummary.complete
    ? environmentSummary.max_temperature_deviation
    : Math.abs((finiteOrNull(session.ambient_temp_avg) ?? familyData.reference_temperature_c ?? 20) - (finiteOrNull(familyData.reference_temperature_c) ?? 20));
  const uTemperature = template.unit === '°' ? 0 : Math.abs(patternMean) * Math.abs(finiteOrNull(familyData.thermal_coefficient_per_c) ?? 0) * deltaTemperature / SQRT3;
  const uGeometry = template.unit === '°' ? 0 : rss([budget.flatness_um, budget.parallelism_um, budget.abbe_um].map((value) => Math.abs(finiteOrNull(value) ?? 0) / 1000 / SQRT3));
  const uOther = Math.abs(finiteOrNull(budget.other_uncertainty_mm) ?? 0) / SQRT3;
  const uStandard = rss([uPatternCalibration, uPatternResolution]);
  const uc = rss([uStandard, uDrift, uInstrumentResolution, uRepeatability, uTemperature, uGeometry, uOther]);
  const k = 2;
  const uExpanded = uc * k;
  const hysteresis = directionMetrics.ASC.count && directionMetrics.DESC.count
    ? Math.abs(directionMetrics.ASC.error_abs - directionMetrics.DESC.error_abs)
    : null;
  const tolerance = finiteOrNull(session.instrument_class);
  let inTolerance = null;
  if (tolerance !== null && tolerance >= 0) inTolerance = familyData.tolerance_mode === 'percent' ? errorPct !== null && Math.abs(errorPct) <= tolerance : Math.abs(errorAbs) <= tolerance;
  return {
    pattern_mean: patternMean, instrument_mean: instrumentMean, error_abs: errorAbs, error_pct: errorPct,
    hysteresis, repeatability, u_standard: uStandard, u_drift: uDrift, u_resolution: uInstrumentResolution,
    u_repeatability: uRepeatability, u_temp: uTemperature, u_other: rss([uGeometry, uOther]), uc, k,
    u_expanded: uExpanded, u_reported: Math.max(uExpanded, Math.abs(Number(session.instrument_resolution) || 0)), in_tolerance: inTolerance, // piso por resolucion del instrumento (QA 2026-09-06)
    uncertainty_components: {
      pattern_calibration: uPatternCalibration, pattern_resolution: uPatternResolution,
      instrument_resolution: uInstrumentResolution, repeatability: uRepeatability,
      temperature_influence: uTemperature, geometry: uGeometry, drift: uDrift, other: uOther,
      reference_codes: [...new Set(evaluations.map((evaluation) => evaluation.snapshot?.asset?.code).filter(Boolean))],
      repeat_count: pairs.length,
      directional_results: directionMetrics,
    },
  };
}
